import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

// Local
import withAuth from 'hoc/withAuth';
import Mam2 from '../components/Mam2';

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({});

const $connect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const $lifecycle = lifecycle({
  componentDidMount() {
    // const { id } = this.props.match.params;
    // this.props.fetchExperiences(id);
  },
  componentWillUnmount() {
    // this.props.clearMam();
  },
});

const enhance = compose(
  $connect,
  $lifecycle,
  withAuth
);

export default enhance(Mam2);
